export enum AtomAnchorSizeEnum {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
  BLANK = "blank",
}
